/**
 * Button Widget Default Configuration
 *
 * Configurable button widget for custom actions.
 */

export type ButtonStyle = 'primary' | 'secondary' | 'tertiary' | 'outline';
export type ButtonSize = 'small' | 'medium' | 'large';

export interface ButtonWidgetConfig {
  displayName: string;
  buttonLabel: string;
  className: string;
  functionName: string;
  style: ButtonStyle;
  size: ButtonSize;
  showIcon: boolean;
  iconPosition: 'left' | 'right';
  iconUrl: string;
  disabled: boolean;
  fullWidth: boolean;
}

export const BUTTON_DEFAULT_CONFIG: ButtonWidgetConfig = {
  displayName: 'Button',
  buttonLabel: 'Button',
  className: '',
  functionName: '',
  style: 'primary',
  size: 'medium',
  showIcon: false,
  iconPosition: 'left',
  iconUrl: '',
  disabled: false,
  fullWidth: false,
};

/**
 * Create default configuration for a button widget
 */
export const createButtonConfig = (): ButtonWidgetConfig => ({
  ...BUTTON_DEFAULT_CONFIG,
});

export default createButtonConfig;
